export var AdSetupDefinition;
(function (AdSetupDefinition) {
    AdSetupDefinition["IMA"] = "ima";
    AdSetupDefinition["DAI_SDK"] = "dai_sdk";
    AdSetupDefinition["DAI_SSB"] = "dai_ssb";
    AdSetupDefinition["DAI_API"] = "dai_api";
    AdSetupDefinition["LINEAR_AD_TRACKING"] = "linear_ad_tracking";
    AdSetupDefinition["NONE"] = "none";
})(AdSetupDefinition || (AdSetupDefinition = {}));
